import React from 'react';
import { FilterTextField, FilterDateTimeRange, Icons, PriceLabel } from 'components';
import { Tooltip } from '@mui/material';
import jMoment from 'moment-jalaali';
import copy from 'copy-to-clipboard';
import { stringLimitShow } from 'utility';
import { TableItemActionsNew } from 'components';
// جت راهنمایی ستون ها به فایل col-help مراجعه نمایید
const columns = (copyItem = copy, openUploadDialog, onOpenTagDg, onOpenRecieptTranaction, classes, actionsList, imprest ,currencyText) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },

  {
    title: 'شماره سند',
    field: 'docId',
    align: 'center',
    filterComponent: (props) => <FilterTextField size="small" variant="outlined" {...props} />,
  },

  {
    title: 'تاریخ',
    field: 'date',
    render: (rowData) => (
      <small>
        <bdi>
          {rowData.date} {rowData.time}
        </bdi>
      </small>
    ),
    filterComponent: (props) => (
      <FilterDateTimeRange
        size="small"
        variant="outlined"
        defaultStartDate={jMoment(new Date()).subtract(7, 'days')}
        defaultEndDate={jMoment(new Date())}
        {...props}
      />
    ),
  },
  {
    title: `موجودی (${currencyText})`,
    field: 'inventory',
    align: 'center',
    filtering: false,
    render: (rowData) => (
      <PriceLabel amount={rowData.inventory} />
    ),
  },
  {
    title: `برداشت (${currencyText})` ,
    field: 'creditor',
    align: 'center',
    render: (rowData) =>
          Number(rowData.priceWithdraw) === 0 ? (
           '-'
         ) : (
           <bdi style={{ color: 'red', direction: 'ltr' }}>
             -
             <PriceLabel amount={rowData.priceWithdraw} />
           </bdi>
         ),
     },
  {
    title: `واریز (${currencyText})` ,
    field: 'deposit',
    align: 'center',
    render: (rowData) =>
    Number(rowData.priceDeposit) === 0  ? (
        '-'
      ) : (
        <bdi style={{ color: 'green' }}>
          +
          <PriceLabel amount={rowData.priceDeposit} />
        </bdi>
      ),
  },
  {
    title: `مانده (${currencyText})` ,
    field: 'accountBalance',
    align: 'center',
    filtering: false,
    render: (rowData) => (
      <PriceLabel amount={rowData.accountBalance} />
    ),
  },
  {
    title: 'شرح سند',
    field: 'description',
    align: 'center',
    filtering: false,
    render: (rowData) => (
      rowData?.description ?
        (<Tooltip enterNextDelay='200' placement='right' title={rowData.description}>
          <div style={{ cursor: 'pointer' }}>
            {stringLimitShow(rowData?.description, 40)}
          </div>
        </Tooltip>) : '-'
    ),
  },
  ...(checkShowActionColumn(actionsList, imprest) ? [{
    title: 'عملیات',
    field: '',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rd) => (
      <TableItemActionsNew
        iconButton
        startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
        title=""
        otherMenus={[
          {
            title: 'مشاهده مدارک',
            isShow: !!(imprest ? (actionsList['imprestTransactionBillDocumentAction'] || actionsList['imprestListReportTransactionDocument']) : actionsList['branchTransactionBillDocumentAction']),
            onClick: () => openUploadDialog(rd),
          },
          {
            title: 'مشاهده برچسب‌ها',
            isShow: !!(imprest ? (actionsList['imprestTransactionBillTagAction'] || actionsList['imprestListReportTransactionTags']) : actionsList['branchTransactionBillTagAction']),
            onClick: () => onOpenTagDg(rd),
          },
          {
            title: 'رسید تراکنش',
            isShow: !!(imprest ? (actionsList['imprestTransactionBillAction'] || actionsList['imprestListReportTransactionRead']) : actionsList['branchTransactionBillAction']),
            onClick: () => onOpenRecieptTranaction(rd),
          },
        ]}
      />
    ),
  }] : []),
];
/**
 * بررسی میکند که آیا حداقل یک مورد از اکشن ها دسترسی دارد یا خیر که ستون عملیات را نشان دهد یا مخفی کند
 */
const checkShowActionColumn = (actionsList, imprest) => {
  if (imprest) { // تراکنش تنخواه گردان است 
    if (actionsList['imprestTransactionBillDocumentAction'] ||
      actionsList['imprestListReportTransactionDocument'] ||
      actionsList['imprestTransactionBillTagAction'] ||
      actionsList['imprestListReportTransactionTags'] ||
      actionsList['imprestTransactionBillAction'] ||
      actionsList['imprestListReportTransactionRead']) {
      return true;
    } else {
      return false
    }

  } else { // تراکنش شعبه است
    if (actionsList['branchTransactionBillDocumentAction'] ||
      actionsList['branchTransactionBillTagAction'] ||
      actionsList['branchTransactionBillAction']) {
      return true;
    } else {
      return false
    }
  }
}

const columnsId = {
  // accountName: '1417',
  docId: '1417',
  date: 'date',
  invoiceId: '1421',
  decreased: '1422',
  withdrawalDeposit: '1420',
  invoiceStatus: '1611',
  RRNId: '1426',
  typeOfTransaction: '1418', // '1596' استثنا برای این مورد که به شناسه تراکنش ارجاع داده می شود.
};

export { columns, columnsId };
